// extracted by css-extract-rspack-plugin
export default {"root":"V4Tx7w","image":"MOx4SN","large":"NctD1k","medium":"eXjeMJ","small":"ykpS5w"};